import { Button } from "./button";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

type BackButtonProps = {
    to: string;
};

export const BackButton = ({ to }: BackButtonProps) => {
    return (
        <Link to={to}>
            <Button variant="outline" size="icon">
                <ArrowLeft className="h-4 w-4" />
            </Button>
        </Link>
    );
};